import React from 'react';
import { Row, Col } from 'antd';
import { useSpring, animated } from 'react-spring';
import { useInView } from 'react-intersection-observer';
import pic1 from '../../asset/landing_images/landing-card1.webp';
import pic2 from '../../asset/landing_images/landing-card2.webp';
import pic3 from '../../asset/landing_images/landing-card3.webp';

const LandingStats = () => {
  const statsSectionStyle = {
    padding: window.innerWidth <= 768 ? '1rem' : '2.5rem',
    // textAlign: 'center',
    backgroundColor: '#ffffff',
    marginTop: window.innerWidth <= 768 ? '2rem' :'5rem',
  };

  const cardBaseStyle = {
    fontSize: window.innerWidth <= 768 ? '1.2em' : '1.5em',
    color: '#ffffff',
    borderRadius: '8px',
    padding: '20px',
    // boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
    display: 'flex',
    justifyContent: 'center',
    alignItems:'center',
    width: '100%',
    height: window.innerWidth <= 768 ? 'auto' :'440px',
    // border:'2px solid red',
    position:'relative',
  };
  const cardText = {
    position: 'absolute',  
    bottom: '20px',       
    left: '20px',         
    alignItems: 'flex-start',
    // border: '2px solid red',
  }
  const firstCardStyle = {
    height: '370px',
    borderRadius:'16px',
    backgroundImage: `url(${pic1})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    position: 'relative',  // Needed for absolute positioning inside
    overflow: 'hidden',    // Prevents content from overflowing
  };

  const secondCardStyle = {
    position: 'relative',
    zIndex: 2,
    margin:' 0 -5%',
    height: '400px',
    borderRadius:'16px',
    backgroundImage: `url(${pic2})`,
    backgroundColor:'#00B2D050',
    opacity:1,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
  };

  const thirdCardStyle = {
    height: '370px',
    borderRadius:'16px',
    backgroundImage: `url(${pic3})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
  };


  const useBounceAnimation = () => {
    const { ref, inView } = useInView({
      triggerOnce: true,
      threshold: 0.1,
    });

    const bounceIn = useSpring({
      transform: inView ? 'translateY(0px)' : 'translateY(150px)',
      opacity: inView ? 1 : 0,
      config: { mass: 1, tension: 280, friction: 12 },
    });

    return { ref, style: bounceIn };
  };

  const firstCardAnimation = useBounceAnimation();
  const secondCardAnimation = useBounceAnimation();
  const thirdCardAnimation = useBounceAnimation();

  return (
    <div style={statsSectionStyle}>
      <Row style={cardBaseStyle}>
        <Col xs={24} sm={24} md={8}>
          <animated.div ref={firstCardAnimation.ref} style={firstCardAnimation.style}>
            <div style={firstCardStyle}>
              <div style={cardText}>
                 <h3 style={{ color:'#000', fontWeight:500, fontSize: "2.5rem"}}>Over</h3>
                 <h3 style={{ fontSize:'3rem', color: "#08839B" }}>20+</h3>
                 <h4 style={{ fontSize: "1.8rem", fontWeight:700, color: "#40AEC3" }}>Jobs posted weekly</h4>
              </div>
            </div>
          </animated.div>
        </Col>

        <Col xs={24} sm={24} md={8}>
          <animated.div ref={secondCardAnimation.ref} style={secondCardAnimation.style}>
            <div style={secondCardStyle}>
              <div style={cardText}>
                <h3 style={{ color:'#000', fontWeight:500, fontSize: "2.5rem"}}>Over</h3>
                <h3 style={{ fontSize:'3rem', color: "#08839B" }}>50,000</h3>
                <h4 style={{ fontSize: "1.8rem", fontWeight:700, color: "#40AEC3" }}>Active monthly users</h4>
              </div>
            </div>
          </animated.div>
        </Col>

        <Col xs={24} sm={24} md={8}>
          <animated.div ref={thirdCardAnimation.ref} style={thirdCardAnimation.style}>
            <div style={thirdCardStyle}>
              <div style={cardText}>
                <h3 style={{ color: "#000", fontWeight: 500, fontSize: "2.5rem" }}>Over</h3>
                <h3 style={{ fontSize:'3rem', color: "#08839B" }}>25,000</h3>
                <h4 style={{ fontSize: "1.8rem", fontWeight:700, color: "#40AEC3" }}>Connections</h4>
              </div>
            </div>
          </animated.div>
        </Col>
      </Row>
    </div>
  );
};

export default LandingStats;
